/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
    CriteriaCategoryToJSONTyped,
} from './CriteriaCategory';

/**
 * 
 * @export
 * @interface FindAllCriteriaCategories200Response
 */
export interface FindAllCriteriaCategories200Response {
    /**
     * 
     */
    data?: Array<CriteriaCategory>;
}

/**
 * Check if a given object implements the FindAllCriteriaCategories200Response interface.
 */
export function instanceOfFindAllCriteriaCategories200Response(value: object): value is FindAllCriteriaCategories200Response {
    return true;
}

export function FindAllCriteriaCategories200ResponseFromJSON(json: any): FindAllCriteriaCategories200Response {
    return FindAllCriteriaCategories200ResponseFromJSONTyped(json, false);
}

export function FindAllCriteriaCategories200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCriteriaCategories200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CriteriaCategoryFromJSON)),
    };
}

export function FindAllCriteriaCategories200ResponseToJSON(json: any): FindAllCriteriaCategories200Response {
    return FindAllCriteriaCategories200ResponseToJSONTyped(json, false);
}

export function FindAllCriteriaCategories200ResponseToJSONTyped(value?: FindAllCriteriaCategories200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CriteriaCategoryToJSON)),
    };
}

